/**
 * robot-manager i18n 工具
 *
 * 共享给所有模块组件，避免每个文件复制相同 helper。
 */

/**
 * 替换模板字符串中的 `{var}` 占位符。
 *
 * 用法：`interpolate('已选 {count} 条', { count: 5 })` → `'已选 5 条'`
 *
 * 未提供的占位符保持 `{var}` 不变，便于发现 i18n 缺参问题。
 */
export function interpolate(tpl: string, vars: Record<string, string | number>): string {
  return tpl.replace(/\{(\w+)\}/g, (_, k) => (k in vars ? String(vars[k]) : `{${k}}`));
}

/**
 * 从带 cnLabel/enLabel 的对象里按 locale 选 label。
 *
 * locale 只在精确等于 `'en'` 时返回 enLabel，其余（zh / zh-CN / 缺省 / 未知）都走 cnLabel。
 * 单点收敛 `isEn ? def.enLabel : def.cnLabel` 模式，避免「page.tsx 用 `locale === 'zh'` 反向判定 /
 * drawer 用 `=== 'en'` 正向判定」这种语义漂移。
 */
export function pickLabel<T extends { cnLabel: string; enLabel: string }>(item: T, locale: string): string {
  return locale === 'en' ? item.enLabel : item.cnLabel;
}
